import { ResourceName } from "../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../core/service/baseApi";
import type { LoadTerminalsFromSiteIdsRequest, TerminalsFromSiteIdsResponse } from "./types";

export const terminalFromSitesApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        loadTerminalFromSiteIds: builder.query<TerminalsFromSiteIdsResponse, LoadTerminalsFromSiteIdsRequest>({
            providesTags: ["mainCache"],
            query: ({ dataGroupCode, siteIds }) => ({
                url: `${ResourceName.DATA_GROUPS}/${dataGroupCode}/get-sites-terminals?ids=${siteIds}`,
                method: "GET",
            }),
        }),
    }),
});

export const { useLoadTerminalFromSiteIdsQuery } = terminalFromSitesApi;
